import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';

export const PartnerLoginReport = async (period) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/PartnerLoginReport`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const DownloadPartnerLoginReport = async () => {
    const result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/DownloadPartnerLoginReport`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}